/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosRequestConfig } from 'axios';

import { baseURL } from '@src/config/http.config';
import { RequestConfig } from '@src/types/common.type';
import { camel2UnderScore, underScore2Camel } from '@src/utils/common';

const instance = axios.create({
  baseURL: baseURL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
});

// 添加全局拦截器，处理登录过期、未登录场景
instance.interceptors.response.use((_response) => {
  let response = _response;
  try {
    if (typeof response == 'string') {
      response = JSON.parse(response);
    }

    const res = response.data;
    // -301 未登录
    if (res?.code == -301) {
      window.location.href = res.url;
      response.data.msg = 'Login expired, please login again';
    }
  } catch (err) {
    console.error(err);
  }
  return response;
});

async function invoke(url: string, params: any, method: string, config?: RequestConfig): Promise<any> {
  let trueParams = params || {};
  if (config?.transformCamelCase !== false) {
    trueParams = camel2UnderScore(trueParams);
  }
  let finalUrl = url;

  // 用 config.pathParams 中的实际值替换路径参数如 ':id'
  if (config?.pathParams) {
    finalUrl = url.replace(/:(\w+)/g, (match, paramName) => String(config.pathParams![paramName] ?? match));
  }

  const reqConfig: AxiosRequestConfig = {
    url: finalUrl,
    method,
    params: method.toLowerCase() === 'get' ? trueParams : undefined,
    data: method.toLowerCase() !== 'get' ? trueParams : undefined,
    ...config,
  };

  const resp = await instance(reqConfig);
  if (config?.transformCamelCase !== false && resp.data) {
    resp.data = underScore2Camel(resp.data);
  }

  return resp.data;
}

const methodRequests = {
  get<T = any>(url: string, params?: any, config?: RequestConfig): Promise<T> {
    return invoke(url, params, 'get', config);
  },

  post<T = any>(url: string, params?: any, config?: RequestConfig): Promise<T> {
    return invoke(url, params, 'post', config);
  },

  put<T = any>(url: string, params?: any, config?: RequestConfig): Promise<T> {
    return invoke(url, params, 'put', config);
  },
  delete<T = any>(url: string, params?: any, config?: RequestConfig): Promise<T> {
    return invoke(url, params, 'delete', config);
  },
  instance,
};

export default methodRequests;
